import { OlympusClient } from '@/OlympusClient'

export const deleteBlockHandler = async (sectionId: string): Promise<void> => {
  await OlympusClient.forms.v1.sections.section.deleteSection({
    params: { sectionId },
  })
}
